import { Query } from '@/_core/cqrs/types/queries';

export class GetNotificationsOfWorkspaceQuery extends Query<NotificationsQueryResult> {
    constructor() {
        super('GetNotificationsOfWorkspaceQuery');
    }
}

export class GetAllNotificationsQuery extends Query<NotificationsQueryResult> {
    constructor() {
        super('GetAllNotificationsQuery');
    }
}

export interface NotificationsQueryResult {
    Notifications: UserNotificationDto[];
    StorymapsWhereCommentingEnabled: string[];
    StorymapUrlTemplate?: string;
}

export interface UserNotificationDto {
    Id: string;
    ToUserId: string;
    NotificationSourceId: string;
    NotificationSourceType: NotificationSourceType;
    NotificationText: string;
    RelatedCardId: string;
    RelatedCardName: string;
    SourceUserName: string;
    SourceUserId: string;
    IsDismissed: boolean;
    HappenedAt: Date;
    IsUpdated: boolean;
    StorymapId: string;
    StorymapName: string;
    RoadmapId?: string;
    RoadmapName: string;
    StorymapSlug: string;
    WorkspaceId: number;
    WorkspaceSubdomain: string;
    WorkspaceName: string;
    ProductSlug: string;
    Replies: UserNotificationReplyDto[];
}

export enum NotificationSourceType {
    MentionedInCardComment = 1,
    MentionedInBoardComment = 2,
    CardCommentAdded = 3,
    BoardCommentAdded = 4,

    FirstEnterToStorymap = 5,

    CardAttachmentAdded = 6,
    CardDescChanged = 7,
    CardEstimationChanged = 8,
    CardStatushanged = 9,

    CardTrashed = 10,

    CardReleaseChanged = 11,

    WorkspaceRoleChanged = 12,
    StorymapRoleChanged = 13,

    InvitedToWorkspace = 14,
    InvitedToStorymap = 15,
    InvitedToStorymapForWsMembers = 16,

    MentionedInIdeaComment = 18,
    MentionedInRoadmapIdeaComment = 19,

    MentionedInFeedbackComment = 20,

    MentionedInRoadmapCardComment = 21,

    CardAssignedToUser = 22,

    MentionedInStorymapCardDescription = 23,

    CardUpdated = 24,
}

export interface UserNotificationReplyDto {
    CommentText: string;
    CommentedAt: Date;
}
